const i18n = require(`./apps/${process.env.APP_NAME}/i18n`)

export default i18n.default
